import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { FacturationService } from '../../common/services/facturation/facturation.service';

@Injectable({
  providedIn: 'root'
})
export class FormADService {

  constructor(public formExtractorService: FormExtractorService, public facturationService: FacturationService) { }
}
